import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { Route, Redirect } from 'react-router-dom'
import { ComponentExt } from '@utils/reactExt'
import { authStore } from 'store'

@inject((store: any) => {
    const { authStore } = store
    return { authStore }
})
@observer
class PrivateRoute extends ComponentExt<any> {
    render() {
        const { component: Component, authRoles, ...rest } = this.props
        if (this.props.authStore) {
            if (this.props.authStore.token && checkRoles(authRoles)) {
                return <Route {...rest} render={() => <Component {...rest} />} />
            } else {
                return <Redirect to={'/login'} />
            }
        }
    }
}

export default PrivateRoute


function checkRoles(authRoles) {

    if (authRoles) {

        let authorized = false
        
        authRoles.forEach(role => {            
            if (authStore.roles.includes(role)) {                
                authorized = true
            }
        });

        return authorized

    } else {
        return true
    }
}
